import {
	LayoutBox,
	TextField,
} from '@bamboohr/fabric';
import {
	Component
} from 'react';

import { OptionalFieldHelp } from '../optional-field-help.react';
import { numberWithinRange } from '../../utils';

export class OptionalTextInput extends Component {
	state = {
		value: this.props.data.amount
	};

	render() {
		const {
			biId = '',
			id,
			data,
			viewOnly,
			help,
			isUnemploymentField,
		} = this.props;

		const namePrefix = isUnemploymentField ? 'uiState' : 'state';

		return <LayoutBox>
			<TextField
				biId={biId}
				disabled={ viewOnly }
				id={ `textInput${ id }` }
				label={ data.label }
				name={ `${ namePrefix }[optional][${ id }]` }
				note={ <OptionalFieldHelp helpData={ help } /> }
				onChange={ this._handleInputChange }
				value={ this.state.value }
			/>
		</LayoutBox>
	}

	_handleInputChange = (event) => {
		const { range } = this.props.data;

		if (range && numberWithinRange(event.target.value, range.min, range.max)) {
			this.setState({
				value: event.target.value
			});
		} else if (!range) {
			this.setState({
				value: event.target.value
			});
		}
	};

}
